import { CameraOutlined, LoadingOutlined } from "@ant-design/icons";
import { t } from "@lingui/macro";
import type { UploadFile, UploadProps } from "antd";
import { Modal, Upload } from "antd";
import { RcFile } from "antd/lib/upload";
import { useEffect, useState } from "react";
import { putFileS3 } from "service/uploadService";
import "./style.scss";
import { customRequestUpload } from "utils";

interface UploadSingleImageProps {
	disabled?: boolean;
	imageUrl: string;
	onChange: (url?: string, path?: string) => void;
	beforeUpload?: (err: string) => void;
	folderUpload?: string;
	maxItem?: number;
	className?: string;
	mimeType?: string;
	accept?: string;
}

interface FileEl {
	uid: string;
	name: string;
	status: string;
	url: string;
}

const UploadSingleImage = (props: UploadSingleImageProps) => {
	const [isLoading, setIsLoading] = useState(false);
	const [imageUrl, setImageUrl] = useState("");
	const [previewVisible, setPreviewVisible] = useState(false);
	const [previewImage, setPreviewImage] = useState("");

	useEffect(() => {
		setImageUrl(props.imageUrl);
	}, [props]);

	const handleChange: UploadProps["onChange"] = async info => {
		if (info.file.status === "removed") {
			setImageUrl("");
			props.onChange();
		} else if (info.file.status === "uploading") {
			setIsLoading(true);
			const resultStr = (await putFileS3(
				info.file.originFileObj as File,
				undefined,
				undefined,
				props?.mimeType,
			)) as {
				url: string;
				path: string;
			};
			props.onChange(resultStr.url, resultStr.path);
			setIsLoading(false);
		}
	};

	function beforeUpload(file: RcFile) {
		const isJpgOrPng =
			file.type === "image/jpeg" ||
			file.type === "image/png" ||
			file.type === "image/gif";
		if (!isJpgOrPng) {
			props.beforeUpload && props.beforeUpload(t`Invalid image format`);
			return false;
		}
		if (isJpgOrPng) {
			props.beforeUpload && props.beforeUpload("");
		}
		return isJpgOrPng;
	}

	const uploadButton = (
		<div>
			{isLoading ? (
				<LoadingOutlined />
			) : (
				<CameraOutlined style={{ fontSize: "20px" }} />
			)}
			{/* <div style={{ marginTop: 8 }}>Upload</div> */}
		</div>
	);

	const handleCancel = () => setPreviewVisible(false);

	const handlePreview = async (file: UploadFile<FileEl>) => {
		setPreviewImage(file.url || "");
		setPreviewVisible(true);
	};

	return (
		<>
			<Upload
				{...props}
				name="imageUrl"
				listType="picture-card"
				fileList={
					imageUrl
						? ([
								{
									uid: "-xxx",
									status: "done",
									url: imageUrl,
									name: "image.png",
								},
						  ] as UploadFile<FileEl>[])
						: []
				}
				className={`single-image-uploader ${props.className || ""}`}
				showUploadList={{ showRemoveIcon: true, showPreviewIcon: true }}
				beforeUpload={beforeUpload}
				onChange={handleChange}
				customRequest={customRequestUpload}
				onPreview={file => handlePreview(file)}
				accept={props?.accept && props.accept}
			>
				{imageUrl ? null : uploadButton}
			</Upload>
			<Modal
				open={previewVisible}
				title={null}
				footer={null}
				onCancel={handleCancel}
			>
				<div className="mt-6">
					<img alt="example" style={{ width: "100%" }} src={previewImage} />
				</div>
			</Modal>
		</>
	);
};

export default UploadSingleImage;
